// extracted by mini-css-extract-plugin
export default {"TableRow":"Uscita_TableRow__ziGHd"};